import { useState } from "react";
import "../styles/components/question.scss";

const base_url = process.env.PUBLIC_URL;

const PageQuestion = ({ page, setResponse }) => {
  const responses = page.responses;

  const [currentResponse, setCurrentResponse] = useState(null);

  const handleSelectResponse = (response) => {
    setCurrentResponse(response.id);
    page.response = response.id;
    setResponse(page);
  };

  return (
    <>
      <div className="step-header" style={{ backgroundColor: `${page.color}`, background: `${page.color}` }}>
        <div className="step-header-wrapper">
          {page.breadcrum && <p className="question-breadcrum">{page.breadcrum}</p>}
          <h3 className="question-text">
            {page.title} &nbsp;
            {page.annotations.length > 0 && <sup>(*)</sup>}
          </h3>
          <span className="question-text-info" dangerouslySetInnerHTML={{ __html: page.content }}></span>
        </div>
      </div>

      <div className="step-footer">
        {responses && (
          <div className="responses-wrapper">
            {page.responses.map((response) => (
              <div className="response" key={response.id}>
                <button
                  className={`response-option ${response.id === currentResponse ? "active" : ""}`}
                  onClick={() => handleSelectResponse(response)}>
                  <span>{response.option}</span>
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default PageQuestion;
